import { actionsNamespace } from "../actions-namespace"
export const a11yNamespace = `${actionsNamespace}a11y/`